<template>
    
</template>

<script>
    import {mapState, mapGettersp} from "vuex";
    export default {
        name: "Home",
        /*beforeRouteEnter(to, from, next) {
            console.log(this.UserInfo)
            if(this.UserInfo.g_idx === 2) {
                next('/member');
            }else if(this.UserInfo.g_idx === 3) {
                next('/member');
            }else if(this.UserInfo.g_idx === 4) {
                next('/theme');
            }else if(this.UserInfo.g_idx === 5) {
                next('/member');
            }
        },*/
        beforeCreate() {
        },
        created() {
            if(this.UserInfo.g_idx === 2) {
                this.$router.push('/member');
            }else if(this.UserInfo.g_idx === 3) {
                this.$router.push('/member');
            }else if(this.UserInfo.g_idx === 4) {
                this.$router.push('/theme');
            }else if(this.UserInfo.g_idx === 5) {
                this.$router.push('/item');
            }
        },
        mounted() {

        },
        computed: {
            ...mapState({
                UserInfo: state => state.userInfo.UserInfo,
            }),

        },

    }
</script>

<style scoped>

</style>